import dayjs from "dayjs";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Empty, Tag, Tooltip } from "antd";

//APP
import { obterExecucoes } from "../talhoesFinalizados/meta";
import { Item__EquipeCliente } from "../../../../../../../services/Equipe/GET";
import { TalhaoFinalizadoSaida } from "../../../meta/dados_modais";
import { leadZero, transition_default } from "../../../../../../../utils";

//COMPONENTS
import { Gap } from "../../../../../../../Components/CustomUi/gap";
import { RowItem } from "../../../../../../../Components/CustomUi/table/rowItem";
import { RowTable } from "../../../../../../../Components/CustomUi/table/rowTable";
import { BodyTable } from "../../../../../../../Components/CustomUi/table/bodyTable";
import { Accordion } from "../../../../../../../Components/CustomUi/accordion"
import { HeaderTable } from "../../../../../../../Components/CustomUi/table/headerTable";
import { ProgressCircle } from "../../../../linhaDoTempo/components/ListaAtividades/components/CardAtv/components/ProgressCircle";

//PROPS
interface Props {
    lista_talhoes_finalizados: TalhaoFinalizadoSaida[];
    data_equipe_cliente: Item__EquipeCliente[];
}

export const Execucoes: React.FC<Props> = ({ lista_talhoes_finalizados, data_equipe_cliente }) => {

    const [open_accordion, setOpen_accordion] = useState<number>(null);

    useEffect(() => {
        if (lista_talhoes_finalizados.filter(i => i.atvs_executadas.length > 0).length === 1) {
            setOpen_accordion(lista_talhoes_finalizados?.[0]?.cod_talhao)
        }
    }, [lista_talhoes_finalizados])

    return (
        <section style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>

            {lista_talhoes_finalizados.filter(i => i.atvs_executadas.length > 0).map(({ nome_talhao, is_subarea, cod_talhao, nome_propriedade, atvs_planejadas, atvs_executadas, atvs_concluidas }, idx) => {
                //@ts-ignore
                let execucoes = atvs_executadas?.map(i => i.andamentos ?? [])?.flat();
                return (
                    <Accordion
                        label={<div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            textAlign: 'left'
                        }}>
                            <span style={{ fontWeight: 600, margin: 0 }}>{nome_talhao} <span style={{ color: 'var(--text-color-light)', fontSize: 12 }}>{is_subarea ? '(Subarea)' : ''}</span></span>
                            <span style={{ fontWeight: 600, fontSize: 11, color: 'var(--primary-color)', margin: 0 }}>{nome_propriedade}</span>
                        </div>}
                        open={cod_talhao === open_accordion}
                        trigger={open_accordion === cod_talhao ? () => { setOpen_accordion(null) } : () => { setOpen_accordion(cod_talhao); }}
                        single
                        extra={<Tags qtd_executadas={execucoes?.length} qtd_planejadas={atvs_planejadas?.length} qtd_concluidas={atvs_concluidas?.length} />}
                    // disabled={atvs_executadas.length === 0}
                    >
                        <motion.div
                            initial={{ opacity: 0, y: -5 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ ...transition_default }}
                        >
                            <Gap value={10} type="column" />

                            <HeaderTable
                                itens={[
                                    { valor: '', width: 30 },
                                    { valor: 'Atividade', width: 235.5 },
                                    { valor: 'Área', width: 100 },
                                    { valor: 'Operador', width: 200.5 },
                                    { valor: 'Data', width: 105 },
                                    { valor: 'Patrimônio', width: 110 },
                                    { valor: 'Insumos', width: 100 },
                                ]}
                            />
                            <BodyTable style={{ overflowX: 'hidden' }}>
                                {(obterExecucoes(atvs_planejadas, atvs_executadas, data_equipe_cliente).executadas ?? []).map(({ descricao_atv_planejada, area_executada,
                                    patrimonios, insumos, data_inicio, operador_nome, prazo }) => {
                                    return (
                                        <RowTable>
                                            <RowItem width={30} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                <Tooltip title={prazo}>
                                                    <div style={{
                                                        width: 20,
                                                        height: 20,
                                                        borderRadius: '100%',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        background: prazo === 'Adiantado' ? '#FFD700' : (prazo === 'Atrasado' ? '#DC143C' : '#7ebc61')
                                                    }} />
                                                </Tooltip>
                                            </RowItem>
                                            <RowItem width={235} style={{ textTransform: 'capitalize', lineHeight: 1.1, fontSize: 13, fontWeight: 500 }}>
                                                {String(descricao_atv_planejada)?.toLowerCase()}
                                            </RowItem>
                                            <RowItem width={100}>
                                                {area_executada} ha
                                            </RowItem>
                                            <RowItem width={200} style={{ textTransform: 'capitalize' }}>
                                                {String(operador_nome)?.toLowerCase()}
                                            </RowItem>
                                            <RowItem width={105}>
                                                {dayjs(data_inicio).format('DD/MM/YYYY')}
                                            </RowItem>
                                            <RowItem width={110}>
                                                <Tooltip title={patrimonios.length === 0 ? '' : patrimonios.map((i) => { return (<>- {String(i.patrimonio_nome)}<br /></>) })}>
                                                    <div style={{
                                                        width: 30, height: 30, borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        background: prazo === 'Adiantado' ? '#FFD700' : (prazo === 'Atrasado' ? '#DC143C' : '#7ebc61'),
                                                        color: "white", fontWeight: 600,
                                                        opacity: (patrimonios ?? [])?.length === 0 ? 0.3 : 1
                                                    }}
                                                    >
                                                        {leadZero((patrimonios ?? [])?.length)}
                                                    </div>
                                                </Tooltip>
                                            </RowItem>
                                            <RowItem width={100}>
                                                <Tooltip title={insumos.map((i) => { return (<>- {String(i.insumo_nome)}<br /></>) })}>
                                                    <div style={{
                                                        width: 30, height: 30, borderRadius: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                        background: prazo === 'Adiantado' ? '#FFD700' : (prazo === 'Atrasado' ? '#DC143C' : '#7ebc61'),
                                                        color: prazo === 'Adiantado' ? 'black' : 'white', fontWeight: 600,
                                                        opacity: (insumos ?? [])?.length === 0 ? 0.3 : 1
                                                    }}
                                                    >
                                                        {leadZero((insumos ?? [])?.length)}
                                                    </div>
                                                </Tooltip>
                                            </RowItem>
                                        </RowTable>
                                    )
                                })}
                            </BodyTable>

                            {(obterExecucoes(atvs_planejadas, atvs_executadas, data_equipe_cliente).executadas ?? []).length === 0 && (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Nenhuma atividade executada!"} />
                            )}


                        </motion.div>
                    </Accordion>
                )
            })}

            {lista_talhoes_finalizados.filter(i => i.atvs_executadas.length > 0).length === 0 && (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"Nenhuma execução foi realizada!"} />
            )}

        </section>
    )
};

//PROPS
interface PropsTags {
    qtd_planejadas: number,
    qtd_executadas: number,
    qtd_concluidas: number,
}
const Tags: React.FC<PropsTags> = ({ qtd_planejadas, qtd_executadas, qtd_concluidas }) => {
    return (
        <div style={{
            display: 'flex',
            gap: 5
        }}>
            <Tag color="green" style={{ fontWeight: 500, alignSelf: 'center' }}>{leadZero(qtd_executadas)} execuções</Tag>

            <ProgressCircle
                progress={(qtd_planejadas === 0 || qtd_concluidas === 0) ? 0 : Math.round((qtd_concluidas / qtd_planejadas) * 100)}
                textColor={"#0958d9"}
                circleColor={"#E6F4FF"}
                progressColor={"#0958d9"}
            />
        </div>
    )
}